import {createAction} from 'redux-actions'
import {geoApi} from '@rambler-id/transport'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {throwError} from 'containers/App/actions'

export const updateGeoInfo = createAction('UPDATE_GEO_INFO')
export const updateGeoSuggest = createAction('UPDATE_GEO_SUGGEST')

export const loadGeoInfo =
  (geoid = 0) =>
  async (dispatch, getState) => {
    if (!getState().geo.cache[geoid]) {
      if (geoid === 0) {
        return
      }

      try {
        const info = await geoApi(`/geo/${geoid}`)

        dispatch(updateGeoInfo(info))
      } catch (error) {
        if (error.code === 0) {
          dispatch(
            throwError(
              'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.'
            )
          )

          return
        }

        Sentry.captureException(error)
      }
    }
  }

export const loadGeoSuggest =
  (name = '', type = '50') =>
  async (dispatch) => {
    try {
      const suggest = await geoApi(
        `/geo_list/?s=${encodeURIComponent(name)}&type=${type}`
      )

      dispatch(updateGeoSuggest(suggest))
    } catch (error) {} // eslint-disable-line no-empty
  }
